import React from "react";
import ReactDOM from "react-dom";
import "bulma/css/bulma.css";
import "@fortawesome/fontawesome-free/js/all";
import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
